import { render, staticRenderFns } from "./ResearchTopic.vue?vue&type=template&id=67c39c5f&scoped=true"
import script from "./ResearchTopic.vue?vue&type=script&lang=js"
export * from "./ResearchTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c39c5f",
  null
  
)

export default component.exports